import React, { useState } from 'react';
import { Button, Popover, Stack, TextField, Tooltip } from '@mui/material';
import PaletteIcon from '@mui/icons-material/Palette';
import iziToast from 'izitoast';

import { setMyColor } from '../../actions/journal';
import { internalServerError } from '../../utils/consts/pathRoutes';

// Палитра различимых цветов: журнал читают быстро, и соседние оттенки в нём бесполезны.
const PRESETS = [
  '#1E88E5', '#00897B', '#43A047', '#FDD835',
  '#FB8C00', '#E53935', '#8E24AA', '#3949AB',
  '#D81B60', '#6D4C41', '#546E7A', '#F4511E',
];

/**
 * Выбор собственного цвета преподавателя — единственная настройка, которую он меняет сам
 * (ТЗ 3.3). Цвет применяется ко всем его действующим группам: он опознаёт человека
 * в журнале, и разные цвета в соседних группах сделали бы легенду бесполезной.
 */
const MyColorPicker = ({ color, onChanged }) => {
  const [anchor, setAnchor] = useState(null);
  const [value, setValue] = useState(color || '#1E88E5');
  const [saving, setSaving] = useState(false);

  const save = (next) => {
    setSaving(true);
    setMyColor(next)
      .then((result) => {
        iziToast.success({
          message: `Цвет обновлён в группах: ${result.groups_updated}`,
          position: 'topRight',
        });
        setAnchor(null);
        onChanged(next);
      })
      .catch((e) => iziToast.error({ message: internalServerError(e), position: 'topRight' }))
      .finally(() => setSaving(false));
  };

  return (
    <>
      <Tooltip title="Мой цвет в журнале">
        <Button
          size="small" startIcon={<PaletteIcon />}
          onClick={(event) => setAnchor(event.currentTarget)}
        >
          <span
            style={{
              width: 14, height: 14, borderRadius: 2, display: 'inline-block',
              background: color || '#d6d6d6', border: '1px solid #d6d6d6',
            }}
          />
        </Button>
      </Tooltip>

      <Popover
        open={Boolean(anchor)} anchorEl={anchor} onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Stack spacing={2} sx={{ p: 2, width: 232 }}>
          <span className="journal-muted">Цвет применится ко всем вашим группам</span>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
            {PRESETS.map((preset) => (
              <button
                key={preset}
                type="button"
                onClick={() => { setValue(preset); save(preset); }}
                disabled={saving}
                title={preset}
                style={{
                  height: 30, borderRadius: 3, cursor: 'pointer', background: preset,
                  border: preset === color ? '3px solid #2f2f2f' : '1px solid #d6d6d6',
                }}
              />
            ))}
          </div>

          <Stack direction="row" spacing={1}>
            <TextField
              label="Свой цвет" value={value} size="small"
              onChange={(event) => setValue(event.target.value)}
              placeholder="#1E88E5"
            />
            <Button
              type="button" variant="contained" size="small"
              disabled={saving} onClick={() => save(value)}
            >
              Ок
            </Button>
          </Stack>
        </Stack>
      </Popover>
    </>
  );
};

export default MyColorPicker;
